import {Injectable} from "@angular/core";
import {ApiService} from "../../../services/api.service";
import {SearchIDsCriteriaDto} from "../../../models/search-ids-criteria-dto"
import {NonprofitsDonorsDetailsSearchDto} from "../../../models/nonprofits-donors-details-search-dto";
import {ReceivedGrantsSearchFilterDto} from "../../../models/received-grants-search-filter-dto";


@Injectable()
export class SearchService {
  constructor(private apiService: ApiService) {}

  contextApi = '/api';

  public getNonprofits(filterParam: SearchIDsCriteriaDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits?loggedInUsername=' + username,
      false,
      true,
      {"filterParam": filterParam},
      null,
      false,
      null
    );
  }

  public getNonprofitsPages(filterParam: SearchIDsCriteriaDto, page: number, pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits/pages',
      false,
      true,
      {
        "page": page,
        "pageSize": pageSize,
        "loggedInUsername": username,
        "filterParam": filterParam
      },
      null,
      false,
      null
    );
  }

  public getNonprofitsForExcel(filterParam: SearchIDsCriteriaDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits/export/excel',
      false,
      true,
      {
        "loggedInUsername": username,
        "filterParam": filterParam
      },
      {responseType: "blob"},
      false,
      null
    );
  }

  public getNonprofitsPagesForExcel(filterParam: SearchIDsCriteriaDto, page: number, pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits/pages/export/excel',
      false,
      true,
      {
        "loggedInUsername": username,
        "page": page,
        "pageSize": pageSize,
        "filterParam": filterParam,
        "format": "CSV"
      },
      {responseType: "blob"},
      false,
      null
    );
  }

  public getNonprofitDonorFullAttributes(nonprofitDonorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits-donors/' + nonprofitDonorId + '/full-attributes?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getNonprofitDonorFullAttributesInExcel(nonprofitDonorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits-donors/' + nonprofitDonorId + '/full-attributes?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  /*
  public getDonors(filterParam: SearchIDsCriteriaDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors?loggedInUsername=' + username,
      false,
      true,
      {"filterParam": filterParam},
      null,
      false,
      null
    );
  }*/

  public getDonorsPages(filterParam: SearchIDsCriteriaDto, page: number, pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/pages',
      false,
      true,
      {
        "page": page,
        "pageSize": pageSize,
        "loggedInUsername": username,
        "filterParam": filterParam
      },
      null,
      false,
      null
    );
  }

  public getDonorsPagesForExcel(filterParam: SearchIDsCriteriaDto, page: number, pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/pages/export/excel',
      false,
      true,
      {
        "format": "CSV",
        "page": page,
        "pageSize": pageSize,
        "loggedInUsername": username,
        "filterParam": filterParam
      },
      {responseType: "blob"},
      false,
      null
    );
  }

  /*
  public getNonprofitFullReportForExcel(nonprofitdonorId: string, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits/'+ nonprofitdonorId +'/full-report/export/excel?loggedInUsername=' + username,
      false,
      true,
      null,
      {responseType: "blob"},
      false,
      null
    );
  }

  public getDonorFullReportForExcel(nonprofitdonorId: string, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/' + nonprofitdonorId + '/full-report/export/excel?loggedInUsername=' + username,
      false,
      true,
      null,
      {responseType: "blob"},
      false,
      null
    );
  }*/

  public getNonprofitDetails(filterParam: NonprofitsDonorsDetailsSearchDto, nonprofitId:number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits/'+ nonprofitId +'/details',
      false,
      true,
      {
        "filterParam": filterParam,
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getDonorDetails(filterParam: NonprofitsDonorsDetailsSearchDto, donorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/'+ donorId +'/details',
      false,
      true,
      {
        "filterParam": filterParam,
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getOrganizationIRSTaxReturnPDFs(nonprofitDonorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/organizations/'+ nonprofitDonorId +'/details/irs-tax-return-pdfs',
      false,
      true,
      {
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }


  public getDonorDetailsRecipients(donorDetailsId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/donor-details/'+ donorDetailsId +'/recipients?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getDonorDetailsRecipientsPages(filterParamTemp: NonprofitsDonorsDetailsSearchDto, page: number,
                                        pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/donors/' + filterParamTemp.nonprofitDonorId + '/details/pages/recipients',
      false,
      true,
      {
        filterParam: filterParamTemp,
        page: page,
        pageSize: pageSize,
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }
  public getReceivedGrantsPages(filterParamTemp: ReceivedGrantsSearchFilterDto, page: number,
                                pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/organizations/' + filterParamTemp.nonprofitDonorId + '/pages/received/grants',
      false,
      true,
      {
        filterParam: filterParamTemp,
        page: page,
        pageSize: pageSize,
        loggedInUsername: username
      },
      null,
      false,
      null
    );
  }

  public getAffiliationCodesDropdown(loggedInUsername: string): any {

    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/affiliation-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getDeductibilityCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/deductibilty-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }


  public getEOSubsectionClassificationCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/eo-subsection-classification-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getFilingReqCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/filing-req-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getTotalAssetsRangeDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/total-assets-range',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getTotalIncomeRangeDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/total-income-range',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getAllGivingInterestsDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/causes/giving-interests',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getUSAStatesDropdown(): any {
    return this.apiService.getCall(
      this.contextApi + '/public/dropdown/states',
      false,
      false,
      null,
      null,
      false,
      null
    );
  }

  public getFoundationCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/foundation-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getNteeCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/ntee-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getNteeParentCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/ntee-parent-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getOrganizationCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/organization-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getPfFilingReqCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/pf-filing-req-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getDonorsCities(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/donors/cities',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getNonprofitsCities(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/nonprofits/cities',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getDonorsCompanyNames(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/donors/company-names',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getDonorsKeyStaff(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/donors/key-staff',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getNonprofitsCompanyNames(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/nonprofits/company-names',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }


  public getReturnTypeCodesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/return-type-codes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getCausesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/causes',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getSearchTypeNamesDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/search-type-names',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }

  public getTaxYearsDropdown(loggedInUsername: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/tax-years',
      false,
      true,
      {
        loggedInUsername: loggedInUsername
      },
      null,
      false,
      null
    );
  }
}
